import { Link, LinkProps, useNavigate } from "react-router-dom"
import { useState, ReactNode } from "react"
import CustomModal from "components/Modals/CustomModal"

interface Props extends LinkProps {
  onClick: () => void
  shouldGuard: boolean
  children: ReactNode
}

export function GuardedLink({ to, onClick, shouldGuard, children, ...props } : Props) {
  const navigate = useNavigate()
  const [modal, setModal] = useState<"confirm-leave" | null>(null)

  const handleClick = (e) => {
    if (!shouldGuard) return
    e.preventDefault()
    setModal("confirm-leave")
  }

  return (
    <>
      <Link to={to} onClick={handleClick} {...props}>
        {children}
      </Link>
      <CustomModal
            showModal={modal === "confirm-leave"}
            header="Confirm leaving the assignment"
            body="Are you sure that you want to leave the assignment?"
            onConfirm={() => {
                setModal(null)
                onClick?.()
                navigate(to)
            }}
            onDecline={() => setModal(null)}
            confirmBtn={{text: "Yes", color: "secondary"}}
            declineBtn={{text: "No", color: "theme"}}
        />
    </>
  )
}
